<template>
  <div class="firm-layout">
    <aside class="firm-sidebar">
      <div class="sidebar-header" @click="goHome">
        <Icon icon="ep:office-building" :size="22" />
        <span class="sidebar-title">{{ firmName || '律所机构端' }}</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        router
        background-color="#1e3a3a"
        text-color="#c8d6d6"
        active-text-color="#e8c87a"
      >
        <el-menu-item :index="firmPath('/workbench')">
          <Icon icon="ep:home-filled" class="menu-icon" />
          <span>工作台</span>
        </el-menu-item>
        <el-menu-item :index="firmPath('/lawyer')">
          <Icon icon="ep:user" class="menu-icon" />
          <span>本所律师</span>
        </el-menu-item>
        <el-menu-item :index="firmPath('/opportunity')">
          <Icon icon="ep:tickets" class="menu-icon" />
          <span>本所商机</span>
        </el-menu-item>
        <el-menu-item :index="firmPath('/case')">
          <Icon icon="ep:document" class="menu-icon" />
          <span>{{ isSelfMode ? '本所案件' : '撮合案件' }}</span>
        </el-menu-item>
        <el-menu-item :index="firmPath('/profile')">
          <Icon icon="ep:office-building" class="menu-icon" />
          <span>本所资料</span>
        </el-menu-item>
        <el-menu-item v-if="firmSettleEnabled" :index="firmPath('/settle')">
          <Icon icon="ep:wallet" class="menu-icon" />
          <span>结算</span>
        </el-menu-item>
        <template v-if="firmErpEnabled">
          <div class="menu-group">办案</div>
          <el-menu-item :index="firmPath('/practice/dashboard')">
            <Icon icon="ep:data-board" class="menu-icon" />
            <span>办案驾驶舱</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/customer')">
            <Icon icon="ep:avatar" class="menu-icon" />
            <span>客户</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/matter')">
            <Icon icon="ep:folder-opened" class="menu-icon" />
            <span>案件工作台</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/time')">
            <Icon icon="ep:timer" class="menu-icon" />
            <span>工时</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/dossier')">
            <Icon icon="ep:document" class="menu-icon" />
            <span>卷宗</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/fee')">
            <Icon icon="ep:coin" class="menu-icon" />
            <span>收费</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/hearing')">
            <Icon icon="ep:calendar" class="menu-icon" />
            <span>开庭</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/task')">
            <Icon icon="ep:list" class="menu-icon" />
            <span>任务</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/deadline')">
            <Icon icon="ep:alarm-clock" class="menu-icon" />
            <span>期限</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/alert')">
            <Icon icon="ep:bell" class="menu-icon" />
            <span>预警</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/invoice')">
            <Icon icon="ep:ticket" class="menu-icon" />
            <span>开票</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/refund')">
            <Icon icon="ep:refresh-left" class="menu-icon" />
            <span>退费</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/commission')">
            <Icon icon="ep:money" class="menu-icon" />
            <span>提成</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/retainer')">
            <Icon icon="ep:notebook" class="menu-icon" />
            <span>顾问</span>
          </el-menu-item>
          <div class="menu-group">所政</div>
          <el-menu-item :index="firmPath('/practice/office/notice')">
            <Icon icon="ep:chat-dot-round" class="menu-icon" />
            <span>公告</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/office/doc')">
            <Icon icon="ep:folder" class="menu-icon" />
            <span>文档</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/office/calendar')">
            <Icon icon="ep:date" class="menu-icon" />
            <span>日历</span>
          </el-menu-item>
          <el-menu-item :index="firmPath('/practice/office/seal')">
            <Icon icon="ep:stamp" class="menu-icon" />
            <span>公章</span>
          </el-menu-item>
        </template>
      </el-menu>
    </aside>
    <div class="firm-main">
      <header class="firm-header">
        <span class="header-title">{{ pageTitle }}</span>
        <div class="header-right">
          <el-button plain size="small" @click="pwdVisible = true">修改密码</el-button>
          <el-button type="danger" plain size="small" @click="handleLogout">
            <Icon icon="ep:switch-button" class="mr-5px" />退出
          </el-button>
        </div>
      </header>
      <main class="firm-content">
        <router-view />
      </main>
    </div>

    <Dialog v-model="pwdVisible" title="修改密码" width="420px">
      <el-form ref="pwdFormRef" :model="pwdForm" :rules="pwdRules" label-width="90px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="pwdForm.oldPassword" type="password" show-password />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="pwdForm.newPassword" type="password" show-password />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="pwdVisible = false">取消</el-button>
        <el-button type="primary" :loading="pwdSaving" @click="submitPwd">保存</el-button>
      </template>
    </Dialog>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import type { FormInstance, FormRules } from 'element-plus'
import { ElMessage, ElMessageBox } from 'element-plus'
import { firmLogout, getFirmWorkbenchContext } from '@/api/firm/auth'
import { FirmPortalApi } from '@/api/firm/portal'
import { removeFirmToken } from '@/utils/auth'
import { firmPath } from '@/views/firm-portal/registry/paths'

defineOptions({ name: 'FirmLayout' })

const route = useRoute()
const router = useRouter()
const firmName = ref(localStorage.getItem('firmName') || '')
const firmErpEnabled = ref(false)
const firmSettleEnabled = ref(true)
const bizMode = ref('')
const isSelfMode = computed(() => String(bizMode.value || '').toUpperCase() === 'SELF')
const activeMenu = computed(() => route.path)
const pageTitle = computed(() => (route.meta?.title as string) || '工作台')

const goHome = () => router.push(firmPath('/workbench'))

const pwdVisible = ref(false)
const pwdSaving = ref(false)
const pwdFormRef = ref<FormInstance>()
const pwdForm = reactive({ oldPassword: '', newPassword: '' })
const pwdRules: FormRules = {
  oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
  newPassword: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    { min: 6, max: 32, message: '密码 6～32 位', trigger: 'blur' }
  ]
}

const submitPwd = async () => {
  await pwdFormRef.value?.validate()
  pwdSaving.value = true
  try {
    await FirmPortalApi.changePassword({ ...pwdForm })
    ElMessage.success('密码已修改')
    pwdVisible.value = false
    pwdForm.oldPassword = ''
    pwdForm.newPassword = ''
  } finally {
    pwdSaving.value = false
  }
}

onMounted(async () => {
  try {
    const ctx = await getFirmWorkbenchContext()
    if (ctx?.firmName) {
      firmName.value = ctx.firmName
      localStorage.setItem('firmName', ctx.firmName)
      localStorage.setItem('firmId', String(ctx.firmId))
    }
    firmErpEnabled.value = !!ctx?.firmErpEnabled
    firmSettleEnabled.value = ctx?.firmSettleEnabled !== false
    bizMode.value = String(ctx?.bizMode || '')
  } catch {
    // 拦截器处理鉴权失败
  }
})

const handleLogout = async () => {
  await ElMessageBox.confirm('确认退出律所机构端？', '提示', { type: 'warning' })
  try {
    await firmLogout()
  } catch {
    // ignore
  }
  removeFirmToken()
  localStorage.removeItem('firmUserType')
  localStorage.removeItem('firmAccountId')
  localStorage.removeItem('firmId')
  localStorage.removeItem('firmName')
  await router.replace(firmPath('/login'))
}
</script>

<style lang="scss" scoped>
.firm-layout {
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: #f5f7f7;
}
.firm-sidebar {
  width: 220px;
  background: #1e3a3a;
  color: #fff;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.sidebar-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 16px;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
}
.sidebar-title {
  font-size: 15px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.menu-icon {
  margin-right: 8px;
}
.menu-group {
  padding: 12px 20px 4px;
  font-size: 12px;
  color: #8aa0a0;
  letter-spacing: 0.04em;
}
.firm-sidebar :deep(.el-menu) {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  border-right: none;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}
.firm-sidebar :deep(.el-menu::-webkit-scrollbar) {
  width: 0;
  height: 0;
  display: none;
}
.firm-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}
.firm-header {
  height: 52px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.header-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e3a3a;
}
.firm-content {
  flex: 1;
  padding: 16px 20px;
  overflow: auto;
  min-height: 0;
}
</style>
